import {
  BasketSummaryEarningsContent,
  BasketSummaryFilterRequest,
  BasketSummaryItem,
} from '@api/api/basket-summary';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import {
  findBasketSummary,
  postBasketSummaryFilterByVersion,
  QUERY_KEY_BASKET_SUMMARY_FILTER,
} from '@terminal/services/basket-summary/basket-summary-service';
import { useFlags } from '@terminal/stores/use-flags/useFlags';

export interface ThemeEarningsSummary {
  content: BasketSummaryEarningsContent;
  updatedAt?: string;
}

export const toThemeEarningsSummary = (
  summary: BasketSummaryItem | undefined
): ThemeEarningsSummary | undefined => {
  if (summary?.summary_type !== 'earnings' || !summary.content) {
    return undefined;
  }

  return {
    content: summary.content,
    updatedAt: summary.updated_at ?? undefined,
  };
};

export const useThemeEarningsSummary = ({
  themeId,
  from,
  to,
}: {
  themeId: string;
  from?: string;
  to?: string;
}) => {
  const isV2 = useFlags(state =>
    state.getFeatureFlagState('KG-976-basket-summary-v2')
  );

  return useQuery({
    queryKey: [QUERY_KEY_BASKET_SUMMARY_FILTER, themeId, 'earnings', from, to],
    enabled: !!themeId && !!from && !!to,
    staleTime: getTimeTillEndOfDayMs(),
    queryFn: ({ signal }) => {
      const body: BasketSummaryFilterRequest = {
        subjects: [{ type: 'theme', id: themeId }],
        summary_types: ['earnings'],
        page: 1,
        page_size: 1,
        from,
        to,
      };

      return postBasketSummaryFilterByVersion({ body, isV2, signal });
    },
    select: summaries =>
      toThemeEarningsSummary(
        findBasketSummary({
          summaries,
          subjectId: themeId,
          summaryType: 'earnings',
        })
      ),
  });
};
